import { Button, Card, Form, Input, InputNumber, message, Space, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ContentWithErrorHandler from '../../app/ContentWithErrorHandler';
import quillConfig from '../../common/quillConfig';
import { useCreateCategoryMutation, useGetCategoryQuery, useUpdateCategoryMutation } from './lotteryAPI';

function LotteryCategoryDetail() {
  const navigate = useNavigate();
  const { poolId, id } = useParams<{ poolId: string; id: string }>();
  const [form] = Form.useForm();
  const [description, setDescription] = useState('');
  const isCreate = !id;

  const { data: categoryData, isLoading: isLoadingCategory } = useGetCategoryQuery(Number(id), {
    skip: isCreate,
  });

  const [createCategory, { isLoading: isCreating }] = useCreateCategoryMutation();
  const [updateCategory, { isLoading: isUpdating }] = useUpdateCategoryMutation();

  useEffect(() => {
    if (categoryData && !isCreate) {
      form.setFieldsValue({
        categoryId: categoryData.categoryId,
        name: categoryData.name,
        maxTickets: categoryData.maxTickets,
        isActive: categoryData.isActive,
      });
      setDescription(categoryData.description || '');
    }
  }, [categoryData, isCreate, form]);

  const onFinish = async (values: any) => {
    try {
      const payload = {
        ...values,
        description,
      };
      if (isCreate) {
        await createCategory({ ...payload, poolId: Number(poolId) }).unwrap();
        message.success('Kategori berhasil dibuat');
      } else {
        await updateCategory({ id: Number(id), ...payload }).unwrap();
        message.success('Kategori berhasil diperbarui');
      }
      navigate(`/lottery/pools/categories/${poolId}`);
    } catch (err: any) {
      message.error(err.data?.message || 'Gagal menyimpan kategori');
    }
  };

  return (
    <ContentWithErrorHandler isError={false} isLoading={isLoadingCategory}>
      <Card title={isCreate ? 'Tambah Kategori' : 'Edit Kategori'} size="small">
        <Form form={form} layout="vertical" onFinish={onFinish} initialValues={{ isActive: true }}>
          <Form.Item label="ID Kategori" name="categoryId" rules={[{ required: true, message: 'Silakan masukkan ID kategori (misal: EMAS, PERAK)' }]}>
            <Input placeholder="misal: EMAS, PERAK, PERUNGGU" />
          </Form.Item>

          <Form.Item label="Nama Kategori" name="name" rules={[{ required: true, message: 'Silakan masukkan nama kategori' }]}>
            <Input placeholder="misal: Tingkat Emas" />
          </Form.Item>

          <Form.Item label="Maksimal Tiket Per Anggota" name="maxTickets" rules={[{ required: true, message: 'Silakan masukkan maksimal tiket' }]}>
            <InputNumber min={1} placeholder="Masukkan jumlah maksimal tiket" />
          </Form.Item>

          <Form.Item label="Deskripsi">
            <ReactQuill
              modules={quillConfig}
              style={{
                background: 'white',
              }}
              onChange={(content) => setDescription(content)}
              value={description}
            />
          </Form.Item>

          <Form.Item label="Aktif" name="isActive" valuePropName="checked">
            <Switch />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={isCreating || isUpdating}>
                {isCreate ? 'Buat' : 'Perbarui'}
              </Button>
              <Button onClick={() => navigate(`/lottery/pools/categories/${poolId}`)}>Batal</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </ContentWithErrorHandler>
  );
}

export default LotteryCategoryDetail;
